export default {
  errorTriggerName: null,
  errorStatus: null,
  errorStartDate: null,
  errorEndDate: null,
  errorMessageTemplate: null,
  errorIsSentViaLine: null,
  errorIsSentViaSms: null,
  errorProductParentCodes: null,
  errorMonthPeriod: null,
  errorAfterFirstBillDayPeriod: null,
  errorIsWithPurchase: null,
  errorIsWithoutPurchase: null,
  errorByCategoriesMessageTemplates: null,
  errorByMembershipMessageTemplates: null,
  errorHasTop40Products: null,
  errorTop40ProductsFilePath: null,
  errorMessageTemplateSmsList: [],
  errorMessageTemplateLineList: [],
  errorMessageTemplatePushNotiList: [],
  errorMessageTemplateSms: null,
  errorMessageTemplateLine: null,
  errorImageRelativePath: null,
  errorTargetUrl: null,
  errorPreviewImageRelativePath: null,
  errorVideoRelativePath: null,
  errorMessageTemplatePushNoti: null,
  errorPushNotiTargetUrl: null,
  errorShowInInbox: null,
  errorShowPeriodInDays: null,
  errorMessageTitle: null,
  errorBillType: null,
  errorMonthNotPurchasePeriod: null,
  errorMinTotalPurchase: null,
  errorDaysAfterLastPurchase: null,
  errorDaysAfterFirstBill: null,
  errorPurchaseSfsLx: null,
  errorMessageTemplatesLineForHv: null,
  errorMessageTemplatesSmsForHv: null,
  errorMessageTemplatesPushNotiForHv: null,
  errorMessageTemplatesLineForLv: null,
  errorMessageTemplatesSmsForLv: null,
  errorMessageTemplatesPushNotiForLv: null,
  errorMinimumSpendingSfsLxHv: null,
  errorMessageTemplatesLineForSfsLxHv: null,
  errorMessageTemplatesSmsForSfsLxHv: null,
  errorMessageTemplatesPushNotiForSfsLxHv: null,
  errorMinimumSpendingSfsLxLv: null,
  errorMessageTemplatesLineForSfsLxLv: null,
  errorMessageTemplatesSmsForSfsLxLv: null,
  errorMessageTemplatesPushNotiForSfsLxLv: null,
  errorMinimumSpendingNonSfsLxHv: null,
  errorMessageTemplatesLineForNonSfsLxHv: null,
  errorMessageTemplatesSmsForNonSfsLxHv: null,
  errorMessageTemplatesPushNotiForNonSfsLxHv: null,
  errorMinimumSpendingNonSfsLxLv: null,
  errorMessageTemplatesLineForNonSfsLxLv: null,
  errorMessageTemplatesSmsForNonSfsLxLv: null,
  errorMessageTemplatesPushNotiForNonSfsLxLv: null,
  errorMessageTemplatesLineForAnyPurchase: null,
  errorMessageTemplatesSmsForAnyPurchase: null,
  errorMessageTemplatesPushNotiForAnyPurchase: null,
};
